import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, vShow as _vShow, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50179118"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_2 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_3 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Itens", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total dos Produtos", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descontos", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Frete", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Seguro", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"background-color":"#000066"}
}
const _hoisted_25 = { style: {"color":"white"} }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-1" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-12",
  style: {"flex-grow":"0"}
}
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-alinhar-desktop-direita-mobile-centro" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-revisao-itens-recebimento-mercadoria-grade-personalizada" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-esquerda" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "-")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-alinhar-texto-esquerda" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-centro" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Unidade")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Quantidade")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Preço Unitário")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor Total R$")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Pedido")
  ])
], -1))
const _hoisted_40 = {
  class: "ant-row",
  style: {"margin-bottom":"4px"}
}
const _hoisted_41 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1",
  style: {"font-size":"20px","text-align":"center","display":"flex","font-weight":"900","align-items":"center","justify-content":"center","background-color":"#f9f9f9"}
}
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-23" }
const _hoisted_43 = {
  class: "ant-row",
  style: {"background-color":"#f9f9f9","padding":"3px 0px"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-centro" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-margin-campos" }, "NF-e")
], -1))
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-9 ss-alinhar-texto-esquerda ss-itens-pd" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-centro ss-itens-pd" }
const _hoisted_48 = ["title"]
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita ss-itens-pd" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita ss-itens-pd" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita ss-itens-pd" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita ss-itens-pd" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "ant-input hidden",
    style: {"text-align":"center"},
    value: '-',
    disabled: true
  })
], -1))
const _hoisted_53 = {
  class: "ant-row ss-table-campos",
  style: 'border-bottom: 2px solid #f9f9f9;'
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-centro" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-margin-campos" }, "Sistema")
], -1))
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-xl-9 ss-alinhar-texto-esquerda ss-itens-pd" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-centro ss-itens-pd" }
const _hoisted_57 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita ss-itens-pd" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita ss-itens-pd" }
const _hoisted_59 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita ss-itens-pd" }
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita ss-itens-pd" }
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "ant-row" }
const _hoisted_63 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-4"
}
const _hoisted_66 = ["disabled"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "ant-row" }
const _hoisted_70 = { class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-alinhar-texto-esquerda" }
const _hoisted_71 = { class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-alinhar-texto-esquerda" }
const _hoisted_72 = ["onUpdate:modelValue", "disabled"]
const _hoisted_73 = { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-esquerda" }
const _hoisted_74 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-alinhar-texto-direita" }
const _hoisted_75 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_76 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_modelo_documento_fiscal = _resolveComponent("selecionar-modelo-documento-fiscal")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_produto_movimento = _resolveComponent("selecionar-produto-movimento")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_selecionar_estoque_produto_movimento = _resolveComponent("selecionar-estoque-produto-movimento")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_selecionar_forma_pagamento = _resolveComponent("selecionar-forma-pagamento")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_recebimento_mercadorias_busca_financeiro = _resolveComponent("recebimento-mercadorias-busca-financeiro")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_recebimento_mercadoria_pagamento_modal = _resolveComponent("recebimento-mercadoria-pagamento-modal")!
  const _component_recebimento_mercadoria_centro_custo_modal = _resolveComponent("recebimento-mercadoria-centro-custo-modal")!
  const _component_buscar_pedido_compra_modal = _resolveComponent("buscar-pedido-compra-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_skeleton, {
            loading: _ctx.state.carregandoDados,
            paragraph: { rows: 15 }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.computedRecebimentoMercadoria.itens.length,
                      disabled: "true"
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.computedRecebimentoMercadoria.notaFiscal.totalProdutos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.computedRecebimentoMercadoria.notaFiscal.totalDesconto, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.computedRecebimentoMercadoria.notaFiscal.totalFrete, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.computedRecebimentoMercadoria.notaFiscal.totalSeguro, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.computedRecebimentoMercadoria.notaFiscal.totalOutrasDespesas, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.computedRecebimentoMercadoria.notaFiscal.totalImpostos.valorAproximadoTributosTotal, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createTextVNode("Total da Nota "),
                      _createVNode(_component_icone, {
                        class: "ss-icone-informacao-campo",
                        nome: "informacoes-fp"
                      })
                    ]),
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      style: {"background-color":"#000066","color":"white","font-weight":"bolder"},
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.computedRecebimentoMercadoria.notaFiscal.totalNotaFiscal, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_26)
                  ])
                ])
              ]),
              _createVNode(_component_card, { titulo: "DOCUMENTO FISCAL" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_a_form_item, {
                        label: "Nº da Nota",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            style: {"text-align":"right"},
                            min: "0",
                            type: "number",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.numeroNotaFiscal) = $event)),
                            disabled: true
                          }, null, 512), [
                            [_vModelText, _ctx.computedRecebimentoMercadoria.notaFiscal.numeroNotaFiscal]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_a_form_item, {
                        label: "Série",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.serie) = $event)),
                            disabled: true
                          }, null, 512), [
                            [_vModelText, _ctx.computedRecebimentoMercadoria.notaFiscal.serie]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_a_form_item, {
                        label: "Modelo",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_modelo_documento_fiscal, {
                            valor: _ctx.computedRecebimentoMercadoria.notaFiscal.modelo,
                            "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.modelo) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_a_form_item, {
                        label: "Data de Emissão",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            "hora-minuto-segundo": true,
                            dataSelecionada: _ctx.computedRecebimentoMercadoria.notaFiscal.dataEmissao,
                            "onUpdate:dataSelecionada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.dataEmissao) = $event)),
                            disabled: true
                          }, null, 8, ["dataSelecionada"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_a_form_item, {
                        label: "Data de Entrada",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            "hora-minuto-segundo": true,
                            dataSelecionada: _ctx.computedRecebimentoMercadoria.notaFiscal.dataEntradaSaida,
                            "onUpdate:dataSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.dataEntradaSaida) = $event)),
                            disabled: false
                          }, null, 8, ["dataSelecionada"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_a_form_item, {
                        label: "Chave de Acesso",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            maxlength: "44",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.chaveAcesso) = $event)),
                            disabled: true
                          }, null, 512), [
                            [_vModelText, _ctx.computedRecebimentoMercadoria.notaFiscal.chaveAcesso]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_selecionar_pessoa, {
                        apresentacaoPersonalizada: true,
                        apresentarCadastro: true,
                        empresas: [_ctx.props.empresa],
                        pessoaPreCadastro: _ctx.state.fornecedorPreCadastro,
                        required: true,
                        label: "Fornecedor",
                        placeholder: "Digite para selecionar ou efetue um novo cadastro",
                        codigoSelecionado: _ctx.computedRecebimentoMercadoria.notaFiscal.emitente.codigoPessoa,
                        "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.emitente.codigoPessoa) = $event)),
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.estrategiaAlteracaoPessoa())),
                        "tipo-relacao": _ctx.ETipoRelacaoPessoa.Fornecedor,
                        style: {"padding-right":"5px"}
                      }, null, 8, ["empresas", "pessoaPreCadastro", "codigoSelecionado", "tipo-relacao"])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_selecionar_pessoa, {
                        empresas: [_ctx.props.empresa],
                        apresentacaoPersonalizada: true,
                        apresentarCadastro: true,
                        pessoaPreCadastro: _ctx.state.transportadoraPreCadastro,
                        label: "Transportadora",
                        placeholder: "Digite para selecionar ou efetue um novo cadastro",
                        preencherCodigoRelacao: true,
                        codigoSelecionado: _ctx.state.codigoPessoaTransportadora,
                        "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.codigoPessoaTransportadora) = $event)),
                        codigoRelacao: _ctx.computedRecebimentoMercadoria.notaFiscal.transporte.codigoTransportadora,
                        "onUpdate:codigoRelacao": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.transporte.codigoTransportadora) = $event)),
                        tipoRelacao: _ctx.ETipoRelacaoPessoa.Transportadora,
                        style: {"padding-left":"30px","padding-right":"1"}
                      }, null, 8, ["empresas", "pessoaPreCadastro", "codigoSelecionado", "codigoRelacao", "tipoRelacao"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "ITENS"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_a_tooltip, {
                            title: "Adicionar item Pelo Pedido de Compra",
                            placement: "left"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.apresentarBuscarPedidoCompra = true))
                              }, [
                                _createVNode(_component_icone, {
                                  style: {"margin-top":"2px"},
                                  nome: "download-arquivo"
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _hoisted_39,
                      ((_ctx.state.chaveItens > 0 && _ctx.state.apresentarItens))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 'CHAVE-ITENS'+ _ctx.state.chaveItens,
                            class: "ss-revisao-itens-recebimento-mercadoria-scroll-movimentos ss-desabilitar-rolagem-horizontal"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedRecebimentoMercadoria.itens, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, _toDisplayString((index + 1)), 1),
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _hoisted_44,
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("input", {
                                          type: "text",
                                          class: "ant-input hidden",
                                          value: item.codigoProdutoNfFornecedor + ' - ' + item.descricaoProdutoNfFornecedor,
                                          disabled: true
                                        }, null, 8, _hoisted_46)
                                      ]),
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("span", {
                                          title: item.unidadeProdutoNfFornecedor
                                        }, _toDisplayString(item.unidadeProdutoNfFornecedor), 9, _hoisted_48)
                                      ]),
                                      _createElementVNode("div", _hoisted_49, [
                                        _createVNode(_component_campo_numerico, {
                                          valor: item.quantidadeNfFornecedor,
                                          quantidadeCasasDecimais: item.itemNotaFiscal.casasDecimaisUnidade,
                                          monetario: false,
                                          disabled: true,
                                          classCss: "ss-campo-numero-table hidden",
                                          classGroupCss: "hidden ss-campo-numero-table"
                                        }, null, 8, ["valor", "quantidadeCasasDecimais"])
                                      ]),
                                      _createElementVNode("div", _hoisted_50, [
                                        _createVNode(_component_campo_numerico, {
                                          valor: item.valorUnitarioNfFornecedor,
                                          quantidadeCasasDecimais: item.itemNotaFiscal.casasDecimaisPrecoUnitario,
                                          monetario: true,
                                          disabled: true,
                                          classCss: "ss-campo-numero-table hidden",
                                          classGroupCss: "hidden ss-campo-numero-table"
                                        }, null, 8, ["valor", "quantidadeCasasDecimais"])
                                      ]),
                                      _createElementVNode("div", _hoisted_51, [
                                        _createVNode(_component_campo_numerico, {
                                          valor: item.valorTotalNfFornecedor,
                                          quantidadeCasasDecimais: 2,
                                          monetario: true,
                                          disabled: true,
                                          classCss: "ss-campo-numero-table hidden",
                                          classGroupCss: "hidden ss-campo-numero-table"
                                        }, null, 8, ["valor"])
                                      ]),
                                      _hoisted_52
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                      _hoisted_54,
                                      _createElementVNode("div", _hoisted_55, [
                                        _createVNode(_component_selecionar_produto_movimento, {
                                          classCss: "hidden ss-campo-selecao-table ss-revisao-itens-recebimento-mercadoria",
                                          classGroupCss: "ss-campo-selecao-table",
                                          title: 'Produto',
                                          dataAttributeColuna: 'Produto',
                                          empresas: [_ctx.props.empresa],
                                          placeholder: "Digite para selecionar ou cadastrar o produto",
                                          buscarDadosAtualizados: _ctx.state.buscaDadosAtualizados,
                                          "onUpdate:buscarDadosAtualizados": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.buscaDadosAtualizados) = $event)),
                                          codigoSelecionado: item.itemNotaFiscal.codigoProdutoDefinicao,
                                          "onUpdate:codigoSelecionado": ($event: any) => ((item.itemNotaFiscal.codigoProdutoDefinicao) = $event),
                                          descricao: item.itemNotaFiscal.descricao,
                                          "onUpdate:descricao": ($event: any) => ((item.itemNotaFiscal.descricao) = $event),
                                          codigoUnidadePrincipal: item.itemNotaFiscal.codigoUnidadePrincipal,
                                          "onUpdate:codigoUnidadePrincipal": ($event: any) => ((item.itemNotaFiscal.codigoUnidadePrincipal) = $event),
                                          fatorUnidadePrincipal: item.itemNotaFiscal.fatorUnidadePrincipal,
                                          "onUpdate:fatorUnidadePrincipal": ($event: any) => ((item.itemNotaFiscal.fatorUnidadePrincipal) = $event),
                                          codigoInterno: item.itemNotaFiscal.codigoProduto,
                                          "onUpdate:codigoInterno": ($event: any) => ((item.itemNotaFiscal.codigoProduto) = $event),
                                          codigoBarras: item.itemNotaFiscal.codigoBarras,
                                          "onUpdate:codigoBarras": ($event: any) => ((item.itemNotaFiscal.codigoBarras) = $event),
                                          origemMercadoria: item.itemNotaFiscal.impostos.origemMercadoria,
                                          "onUpdate:origemMercadoria": ($event: any) => ((item.itemNotaFiscal.impostos.origemMercadoria) = $event),
                                          codigoNcm: item.itemNotaFiscal.impostos.codigoNcm,
                                          "onUpdate:codigoNcm": ($event: any) => ((item.itemNotaFiscal.impostos.codigoNcm) = $event),
                                          ncm: item.itemNotaFiscal.impostos.ncm,
                                          "onUpdate:ncm": ($event: any) => ((item.itemNotaFiscal.impostos.ncm) = $event),
                                          siglaUnidade: item.itemNotaFiscal.siglaUnidade,
                                          "onUpdate:siglaUnidade": ($event: any) => ((item.itemNotaFiscal.siglaUnidade) = $event),
                                          emDigitacao: item.emDigitacao,
                                          "onUpdate:emDigitacao": ($event: any) => ((item.emDigitacao) = $event),
                                          codigoPedidoCompra: _ctx.state.codigoPedidoCompra,
                                          codigoItemPedidoCompra: item.codigoPedidoCompra,
                                          "onUpdate:codigoItemPedidoCompra": ($event: any) => ((item.codigoPedidoCompra) = $event),
                                          disabled: false,
                                          limparSelecao: false,
                                          apresentarCadastro: true,
                                          produtoPreCadastro: _ctx.state.produtosPreCadastro[index],
                                          onKeydown: [
                                            _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                            _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(item.emDigitacao, $event)), ["prevent"]), ["left"]),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(item.emDigitacao, $event)), ["prevent"]), ["right"]),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAbaixo(item.emDigitacao, $event, 'Produto')), ["prevent"]), ["down"]),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAcima(item.emDigitacao, $event, 'Produto')), ["prevent"]), ["up"])
                                          ]
                                        }, null, 8, ["empresas", "buscarDadosAtualizados", "codigoSelecionado", "onUpdate:codigoSelecionado", "descricao", "onUpdate:descricao", "codigoUnidadePrincipal", "onUpdate:codigoUnidadePrincipal", "fatorUnidadePrincipal", "onUpdate:fatorUnidadePrincipal", "codigoInterno", "onUpdate:codigoInterno", "codigoBarras", "onUpdate:codigoBarras", "origemMercadoria", "onUpdate:origemMercadoria", "codigoNcm", "onUpdate:codigoNcm", "ncm", "onUpdate:ncm", "siglaUnidade", "onUpdate:siglaUnidade", "emDigitacao", "onUpdate:emDigitacao", "codigoPedidoCompra", "codigoItemPedidoCompra", "onUpdate:codigoItemPedidoCompra", "produtoPreCadastro", "onKeydown"])
                                      ]),
                                      _createElementVNode("div", _hoisted_56, [
                                        _createVNode(_component_selecionar_unidade_produto_movimento, {
                                          classCss: "hidden ss-campo-selecao-table ss-recebimento-mercadoria-itens",
                                          classGroupCss: "ss-campo-selecao-table",
                                          apenasUnidadePrincipal: false,
                                          dataAttributeColuna: 'Unidade',
                                          title: item.itemNotaFiscal.descricaoUnidade,
                                          codigoProdutoDefinicao: item.itemNotaFiscal.codigoProdutoDefinicao,
                                          codigoUnidadeSelecionada: item.itemNotaFiscal.codigoUnidade,
                                          "onUpdate:codigoUnidadeSelecionada": ($event: any) => ((item.itemNotaFiscal.codigoUnidade) = $event),
                                          descricao: item.itemNotaFiscal.descricaoUnidade,
                                          "onUpdate:descricao": ($event: any) => ((item.itemNotaFiscal.descricaoUnidade) = $event),
                                          sigla: item.itemNotaFiscal.siglaUnidade,
                                          "onUpdate:sigla": ($event: any) => ((item.itemNotaFiscal.siglaUnidade) = $event),
                                          casasDecimais: item.itemNotaFiscal.casasDecimaisUnidade,
                                          "onUpdate:casasDecimais": ($event: any) => ((item.itemNotaFiscal.casasDecimaisUnidade) = $event),
                                          fatorConversao: item.itemNotaFiscal.fatorConversao,
                                          "onUpdate:fatorConversao": ($event: any) => ((item.itemNotaFiscal.fatorConversao) = $event),
                                          apresentarApenasSigla: true,
                                          onKeydown: [
                                            _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                            _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                            _cache[16] || (_cache[16] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(item.emDigitacao, $event)), ["prevent"]), ["left"]),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(item.emDigitacao, $event)), ["prevent"]), ["right"]),
                                            _cache[17] || (_cache[17] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event,'Unidade')), ["prevent"]), ["down"])),
                                            _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event,'Unidade')), ["prevent"]), ["up"]))
                                          ]
                                        }, null, 8, ["title", "codigoProdutoDefinicao", "codigoUnidadeSelecionada", "onUpdate:codigoUnidadeSelecionada", "descricao", "onUpdate:descricao", "sigla", "onUpdate:sigla", "casasDecimais", "onUpdate:casasDecimais", "fatorConversao", "onUpdate:fatorConversao", "onKeydown"])
                                      ]),
                                      _createElementVNode("div", _hoisted_57, [
                                        _withDirectives((_openBlock(), _createBlock(_component_selecionar_estoque_produto_movimento, {
                                          empresas: [_ctx.props.empresa],
                                          movimentarEntrada: true,
                                          codigoProdutoDefinicao: item.itemNotaFiscal.codigoProdutoDefinicao,
                                          codigoUnidadePrincipal: item.itemNotaFiscal.codigoUnidadePrincipal,
                                          fatorConversaoUnidadePrincipal: item.itemNotaFiscal.fatorUnidadePrincipal,
                                          codigoUnidadeSelecionada: item.itemNotaFiscal.codigoUnidade,
                                          fatorConversaoUnidadeSelecionada: item.itemNotaFiscal.fatorConversao,
                                          estoquesMovimento: item.estoquesMovimento,
                                          "onUpdate:estoquesMovimento": ($event: any) => ((item.estoquesMovimento) = $event),
                                          quantidade: item.itemNotaFiscal.quantidade,
                                          "onUpdate:quantidade": ($event: any) => ((item.itemNotaFiscal.quantidade) = $event),
                                          itensEstoque: item.itemNotaFiscal.estoques,
                                          "onUpdate:itensEstoque": ($event: any) => ((item.itemNotaFiscal.estoques) = $event),
                                          classCss: "ss-revisao-itens-recebimento-mercadoria",
                                          processando: _ctx.state.carregando,
                                          "onUpdate:processando": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.carregando) = $event)),
                                          disabled: false,
                                          index: index,
                                          apresentarEstoques: (_ctx.state.apresentarEstoquesItem && _ctx.state.indexDetalhesEstoques === index),
                                          popOverHover: _ctx.state.popOverHoverEstoqueItem,
                                          "onUpdate:popOverHover": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.popOverHoverEstoqueItem) = $event)),
                                          inputFocus: _ctx.state.inputFocusEstoqueItem,
                                          "onUpdate:inputFocus": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.inputFocusEstoqueItem) = $event)),
                                          identificacaoElemento: ('QTDE' + item.itemNotaFiscal.codigoProdutoDefinicao + _ctx.state.chaveItens + index),
                                          key: ('SEL-QTDE' + item.itemNotaFiscal.codigoProdutoDefinicao + _ctx.state.chaveItens + index),
                                          onBlur: _ctx.quantidadeBlur
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_component_campo_numerico, {
                                              dataAttributeColuna: 'Quantidade',
                                              title: 'Quantidade',
                                              classCss: "hidden ss-campo-numero-table ss-revisao-itens-recebimento-mercadoria",
                                              classGroupCss: "hidden ss-campo-numero-table ant-input",
                                              valor: item.itemNotaFiscal.quantidade,
                                              "onUpdate:valor": ($event: any) => ((item.itemNotaFiscal.quantidade) = $event),
                                              emDigitacao: item.emDigitacao,
                                              "onUpdate:emDigitacao": ($event: any) => ((item.emDigitacao) = $event),
                                              fracionar: (item.itemNotaFiscal.fracionarUnidade),
                                              quantidadeCasasDecimais: item.itemNotaFiscal.casasDecimaisUnidade,
                                              disabled: false,
                                              key: ('QTDE' + item.itemNotaFiscal.codigoProdutoDefinicao + _ctx.state.chaveItens + index),
                                              onFocus: ($event: any) => (_ctx.quantidadeFoco(index)),
                                              onBlur: _ctx.quantidadeBlur,
                                              onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index)),
                                              onKeydown: [
                                                _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                                _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(item.emDigitacao, $event)), ["prevent"]), ["left"]),
                                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(item.emDigitacao, $event)), ["prevent"]), ["right"]),
                                                _cache[21] || (_cache[21] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, 'Quantidade')), ["prevent"]), ["down"])),
                                                _cache[22] || (_cache[22] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, 'Quantidade')), ["prevent"]), ["up"]))
                                              ]
                                            }, null, 8, ["valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "fracionar", "quantidadeCasasDecimais", "onFocus", "onBlur", "onValorDigitado", "onKeydown"]))
                                          ]),
                                          _: 2
                                        }, 1032, ["empresas", "codigoProdutoDefinicao", "codigoUnidadePrincipal", "fatorConversaoUnidadePrincipal", "codigoUnidadeSelecionada", "fatorConversaoUnidadeSelecionada", "estoquesMovimento", "onUpdate:estoquesMovimento", "quantidade", "onUpdate:quantidade", "itensEstoque", "onUpdate:itensEstoque", "processando", "index", "apresentarEstoques", "popOverHover", "inputFocus", "identificacaoElemento", "onBlur"])), [
                                          [_vShow, (item.itemNotaFiscal.codigoProdutoDefinicao > 0)]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_58, [
                                        _createVNode(_component_campo_numerico, {
                                          dataAttributeColuna: 'PrecoUnitario',
                                          valor: item.itemNotaFiscal.precoUnitario,
                                          "onUpdate:valor": ($event: any) => ((item.itemNotaFiscal.precoUnitario) = $event),
                                          monetario: true,
                                          disabled: false,
                                          quantidadeCasasDecimais: item.itemNotaFiscal.casasDecimaisPrecoUnitario,
                                          classCss: "ss-campo-numero-table hidden ss-revisao-itens-recebimento-mercadoria",
                                          classGroupCss: "hidden ss-campo-numero-table",
                                          onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index)),
                                          onKeydown: [
                                            _cache[26] || (_cache[26] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                            _cache[27] || (_cache[27] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(item.emDigitacao, $event)), ["prevent"]), ["left"]),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(item.emDigitacao, $event)), ["prevent"]), ["right"]),
                                            _cache[28] || (_cache[28] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, 'PrecoUnitario')), ["prevent"]), ["down"])),
                                            _cache[29] || (_cache[29] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, 'PrecoUnitario')), ["prevent"]), ["up"]))
                                          ]
                                        }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais", "onValorDigitado", "onKeydown"])
                                      ]),
                                      _createElementVNode("div", _hoisted_59, [
                                        _createVNode(_component_campo_numerico, {
                                          title: 'ValorTotal',
                                          valor: item.itemNotaFiscal.valorTotal,
                                          quantidadeCasasDecimais: 2,
                                          monetario: true,
                                          disabled: true,
                                          classGroupCss: "hidden ss-campo-numero-table",
                                          classCss: "ss-campo-numero-table hidden"
                                        }, null, 8, ["valor"])
                                      ]),
                                      _createElementVNode("div", _hoisted_60, [
                                        _createElementVNode("input", {
                                          type: "text",
                                          class: "ant-input hidden",
                                          style: {"text-align":"center"},
                                          value: item.numeroPedidoCompra,
                                          disabled: true
                                        }, null, 8, _hoisted_61)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: "DETALHES DE PAGAMENTO"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createVNode(_component_selecionar_forma_pagamento, {
                            apresentacaoPersonalizada: true,
                            empresas: [_ctx.props.empresa],
                            codigoSelecionado: _ctx.computedRecebimentoMercadoria.codigoFormaPagamento,
                            "onUpdate:codigoSelecionado": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.codigoFormaPagamento) = $event)),
                            "tipo-movimento": _ctx.ETipoMovimentoComercial.Compras,
                            required: true,
                            onChange: _ctx.atualizarFormaPagamento
                          }, null, 8, ["empresas", "codigoSelecionado", "tipo-movimento", "onChange"])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass((_ctx.computedRecebimentoMercadoria.notaFiscal.detalhesPagamento.length > 1)?'ant-col ant-col-xs-24 ant-col-xl-4':'ant-col ant-col-xs-24 ant-col-xl-6')
                        }, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary ss-tamanho-completo ss-acao-destaque-secundaria",
                                disabled: !_ctx.UtilitarioGeral.validaCodigo(_ctx.computedRecebimentoMercadoria.codigoFormaPagamento),
                                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.adicionarPagamento && _ctx.adicionarPagamento(...args)))
                              }, "Adicionar Pagamento", 8, _hoisted_64)
                            ]),
                            _: 1
                          })
                        ], 2),
                        ((_ctx.computedRecebimentoMercadoria.notaFiscal.detalhesPagamento.length > 1))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _createVNode(_component_a_form_item, {
                                label: " ",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    class: "ant-btn ant-btn-secondary ss-tamanho-completo ss-acao-destaque-secundaria",
                                    onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.removerTodosPagamentos && _ctx.removerTodosPagamentos(...args)))
                                  }, "Remover todos Pagamentos")
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass((_ctx.computedRecebimentoMercadoria.notaFiscal.detalhesPagamento.length > 1)?'ant-col ant-col-xs-24 ant-col-xl-4':'ant-col ant-col-xs-24 ant-col-xl-6')
                        }, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary ss-tamanho-completo ss-acao-destaque-secundaria",
                                disabled: !_ctx.UtilitarioGeral.validaCodigo(_ctx.computedRecebimentoMercadoria.codigoFormaPagamento),
                                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.apresentarBuscarVincularTitulos && _ctx.apresentarBuscarVincularTitulos(...args)))
                              }, "Buscar/Vincular Títulos", 8, _hoisted_66)
                            ]),
                            _: 1
                          })
                        ], 2)
                      ]),
                      (!_ctx.UtilitarioGeral.validaCodigo(_ctx.computedRecebimentoMercadoria.codigoFormaPagamento))
                        ? (_openBlock(), _createBlock(_component_a_alert, {
                            key: 0,
                            message: "Selecione uma Forma de pagamento para editar ou lançar os detalhes do pagamento.",
                            type: "warning",
                            "show-icon": ""
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedRecebimentoMercadoria.notaFiscal.detalhesPagamento, (detalhePagamento, index) => {
                        return (_openBlock(), _createBlock(_component_card, {
                          key: 'PGTO' + index,
                          titulo: _ctx.montaTituloPagamento(index,detalhePagamento)
                        }, {
                          AcoesExtra: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "ss-fonte-negrito ss-card-botao-acao-extra-secundaria",
                              title: "Remover",
                              onClick: ($event: any) => (_ctx.excluirPagamento(index))
                            }, "Remover ", 8, _hoisted_67),
                            _createElementVNode("a", {
                              class: "ss-fonte-negrito ss-card-botao-acao-extra-secundaria",
                              title: "Centro Custo",
                              onClick: ($event: any) => (_ctx.adicionarCentroCusto(index))
                            }, "Centro de Custo ", 8, _hoisted_68)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _createVNode(_component_a_form_item, {
                                  label: "Tipo de Documento",
                                  class: "ss-margin-campos",
                                  rules: [{ required: true }]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_tipo_documento_financeiro, {
                                      empresas: [_ctx.props.empresa],
                                      codigoSelecionado: detalhePagamento.codigoTipoDocumentoFinanceiro,
                                      "onUpdate:codigoSelecionado": ($event: any) => ((detalhePagamento.codigoTipoDocumentoFinanceiro) = $event),
                                      descricaoSelecionado: detalhePagamento.descricaoTipoDocumentoFinanceiro,
                                      "onUpdate:descricaoSelecionado": ($event: any) => ((detalhePagamento.descricaoTipoDocumentoFinanceiro) = $event),
                                      tiposDocumentosEspecificos: _ctx.UtilitarioGeral.validaCodigo(detalhePagamento.codigoTituloFinanceiro)?[]:_ctx.state.codigosTiposDocumentosFinanceiros,
                                      disabled: (!_ctx.UtilitarioGeral.validaCodigo(_ctx.computedRecebimentoMercadoria.codigoFormaPagamento) || (_ctx.UtilitarioGeral.validaCodigo(detalhePagamento.codigoTituloFinanceiro))),
                                      onChange: ($event: any) => (_ctx.verificaPreenchimentoDefinicaoTipoDocumento(index))
                                    }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "descricaoSelecionado", "onUpdate:descricaoSelecionado", "tiposDocumentosEspecificos", "disabled", "onChange"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _createVNode(_component_a_form_item, {
                                  label: "N.Identificação",
                                  class: "ss-margin-campos",
                                  rules: [{ required: true }]
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "ant-input",
                                      "onUpdate:modelValue": ($event: any) => ((detalhePagamento.numeroTitulo) = $event),
                                      disabled: _ctx.UtilitarioGeral.validaCodigo(detalhePagamento.codigoTituloFinanceiro)
                                    }, null, 8, _hoisted_72), [
                                      [_vModelText, detalhePagamento.numeroTitulo]
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createVNode(_component_a_form_item, {
                                  label: "Vencimento",
                                  class: "ss-margin-campos",
                                  rules: [{ required: true }]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_data, {
                                      dataSelecionada: detalhePagamento.data,
                                      "onUpdate:dataSelecionada": ($event: any) => ((detalhePagamento.data) = $event),
                                      disabled: _ctx.UtilitarioGeral.validaCodigo(detalhePagamento.codigoTituloFinanceiro)
                                    }, null, 8, ["dataSelecionada", "onUpdate:dataSelecionada", "disabled"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor",
                                  class: "ss-margin-campos",
                                  rules: [{ required: true }]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      valor: detalhePagamento.valorPagamento,
                                      "onUpdate:valor": ($event: any) => ((detalhePagamento.valorPagamento) = $event),
                                      monetario: true,
                                      disabled: (detalhePagamento.codigoTituloFinanceiro > 0)
                                    }, null, 8, ["valor", "onUpdate:valor", "disabled"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _createVNode(_component_selecionar_conta, {
                                  empresas: [_ctx.props.empresa],
                                  required: true,
                                  codigoSelecionado: detalhePagamento.codigoConta,
                                  "onUpdate:codigoSelecionado": ($event: any) => ((detalhePagamento.codigoConta) = $event),
                                  descricaoSelecionado: detalhePagamento.descricaoConta,
                                  "onUpdate:descricaoSelecionado": ($event: any) => ((detalhePagamento.descricaoConta) = $event),
                                  onChange: ($event: any) => (_ctx.verificaPreenchimentoDefinicaoConta(index)),
                                  disabled: (!_ctx.UtilitarioGeral.validaCodigo(_ctx.computedRecebimentoMercadoria.codigoFormaPagamento) || (_ctx.UtilitarioGeral.validaCodigo(detalhePagamento.codigoTituloFinanceiro)))
                                }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "descricaoSelecionado", "onUpdate:descricaoSelecionado", "onChange", "disabled"])
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _createVNode(_component_a_form_item, {
                                  label: "Categoria",
                                  class: "ss-margin-campos",
                                  rules: [{ required: true }]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_categoria_plano_conta, {
                                      empresas: [_ctx.props.empresa],
                                      tipoPlanoConta: 1,
                                      codigoSelecionado: detalhePagamento.codigoPlanoContaCategoria,
                                      "onUpdate:codigoSelecionado": ($event: any) => ((detalhePagamento.codigoPlanoContaCategoria) = $event),
                                      descricaoSelecionado: detalhePagamento.nomePlanoContaCategoria,
                                      "onUpdate:descricaoSelecionado": ($event: any) => ((detalhePagamento.nomePlanoContaCategoria) = $event),
                                      onChange: ($event: any) => (_ctx.verificaPreenchimentoDefinicaoCategoria(index)),
                                      disabled: (!_ctx.UtilitarioGeral.validaCodigo(_ctx.computedRecebimentoMercadoria.codigoFormaPagamento) || (_ctx.UtilitarioGeral.validaCodigo(detalhePagamento.codigoTituloFinanceiro)))
                                    }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "descricaoSelecionado", "onUpdate:descricaoSelecionado", "onChange", "disabled"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["titulo"]))
                      }), 128)),
                      (_ctx.state.apresentarBuscaFinanceiro)
                        ? (_openBlock(), _createBlock(_component_recebimento_mercadorias_busca_financeiro, {
                            key: 1,
                            empresa: _ctx.props.empresa,
                            editavel: true,
                            codigoPessoa: _ctx.computedRecebimentoMercadoria.notaFiscal.emitente.codigoPessoa,
                            detalhesPagamento: _ctx.computedRecebimentoMercadoria.notaFiscal.detalhesPagamento,
                            "onUpdate:detalhesPagamento": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.notaFiscal.detalhesPagamento) = $event)),
                            totalNotaFiscal: _ctx.computedRecebimentoMercadoria.notaFiscal.totalNotaFiscal
                          }, null, 8, ["empresa", "codigoPessoa", "detalhesPagamento", "totalNotaFiscal"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_recebimento_mercadoria_pagamento_modal, {
      "tipos-documentos": _ctx.state.codigosTiposDocumentosFinanceiros,
      recebimento: _ctx.computedRecebimentoMercadoria,
      "onUpdate:recebimento": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedRecebimentoMercadoria) = $event)),
      editavel: _ctx.state.editavel,
      detalhePagamento: _ctx.state.detalhePagamento,
      visivel: _ctx.state.apresentarParcelamento,
      "onUpdate:visivel": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.apresentarParcelamento) = $event)),
      revisarInformacoes: true
    }, null, 8, ["tipos-documentos", "recebimento", "editavel", "detalhePagamento", "visivel"]),
    _createVNode(_component_recebimento_mercadoria_centro_custo_modal, {
      visivel: _ctx.state.apresentarCentroCusto,
      "onUpdate:visivel": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.apresentarCentroCusto) = $event)),
      detalhePagamento: _ctx.state.detalhePagamento,
      "onUpdate:detalhePagamento": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.detalhePagamento) = $event)),
      onConfirmar: _ctx.verificaPreenchimentoCentroCusto
    }, null, 8, ["visivel", "detalhePagamento", "onConfirmar"]),
    _createVNode(_component_buscar_pedido_compra_modal, {
      visivel: _ctx.state.apresentarBuscarPedidoCompra,
      "onUpdate:visivel": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.apresentarBuscarPedidoCompra) = $event)),
      empresa: _ctx.props.empresa,
      codigoFornecedor: _ctx.computedRecebimentoMercadoria.notaFiscal.emitente.codigoPessoa,
      numeroPedidoCompra: _ctx.computedRecebimentoMercadoria.numeroPedido,
      "onUpdate:numeroPedidoCompra": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.computedRecebimentoMercadoria.numeroPedido) = $event)),
      codigoPedidoCompra: _ctx.state.codigoPedidoCompra,
      "onUpdate:codigoPedidoCompra": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.codigoPedidoCompra) = $event)),
      onConfirmar: _ctx.adicionarItensPedido
    }, null, 8, ["visivel", "empresa", "codigoFornecedor", "numeroPedidoCompra", "codigoPedidoCompra", "onConfirmar"])
  ], 64))
}